export class SystemMaintanceModel {
    title = '';
    description = '';
    type = '';
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/models/systemMaintance.model.ts